import React from "react";
import { CategoryIcon } from "../assets/tileIcons";
import Tooltip, { HelpTip } from "./Tooltip";


const iconSvgs = {
	eraser: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 343.5341 294.0618"
			width="20"
			height="20"
			aria-hidden="true"
		>
			<path d="M333.322,145.9483l-110.6377,110.6119L86.9688,120.8553,197.3268,10.4452c14.4152-14.422,37.4445-13.6602,51.5096.7443l83.9054,83.9052c13.9922,14.1758,14.5816,35.8932.5801,50.8536Z" />
			<path d="M62.7734,294.0618c-4.6052.0003-7.6208-1.373-10.0777-3.8307l-41.9855-41.9977c-13.9998-14.0808-14.4779-36.6933-.2351-50.9379l59.5228-59.5303,132.2552,132.2692,96.6834.0384c6.9268.0028,11.8448,5.4016,12.0509,11.4231.2239,6.5429-4.6474,12.5506-12.1478,12.5511l-236.0663.0146Z" />
		</svg>
	),
};

export default function Tile({ 
	title, 
	type, 
	cols=1, 
	rows=1, 
	col=1, 
	row=1, 
	category,
	iconHover,
	description, 
	children, 
	onClear, 
	hasFilter 
}) {
	return (
		<section
			className={`card ${category}`}
			style={{ gridColumn: `${col} / span ${cols}`, gridRow: `${row} / span ${rows}` }}
		>
			{title && (
				<h3 className="card-title">
					<span className="title-left">
							<Tooltip content={iconHover || title} placement="top">
								<CategoryIcon category={category} className="title-icon" />
							</Tooltip>
						<span className="title-text">{title}</span>
						<HelpTip text={description} />
					</span>
					<button
						className={`end-icon ${hasFilter ? "" : "disabled"}`}
						aria-label={`Clear filters for ${title}`}
						title="Erase filters"
						onClick={hasFilter ? onClear : undefined}
						aria-disabled={!hasFilter}
					>
						{iconSvgs.eraser}
					</button>
				</h3>
			)}
			<div className={`body ${type || ""}`}>{children}</div>
		</section>
	);
}
